  (function () {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer || drawer.dataset.bm2Init) return;
    drawer.dataset.bm2Init = 'true';

    drawer.querySelectorAll('[data-bm2-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        drawer.querySelectorAll('[data-bm2-tab]').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        drawer.querySelectorAll('[data-bm2-menu]').forEach(function (menu) {
          menu.classList.toggle('is-active', menu.dataset.bm2Menu === tab.dataset.bm2Tab);
        });
      });
    });

    drawer.querySelectorAll('[data-bm2-acc] .bm2__acc-btn:not([data-bm2-open-panel])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc = btn.closest('[data-bm2-acc]');
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        // Exclusive accordions: opening one closes every other open one.
        if (open) {
          drawer.querySelectorAll('[data-bm2-acc].is-open').forEach(function (other) {
            if (other === acc) return;
            other.classList.remove('is-open');
            var otherBtn = other.querySelector('.bm2__acc-btn');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          });
          // Reveal the opened accordion: scroll only the minimum needed to
          // bring the just-expanded body into view — nothing if it already
          // fits, and never so far that the header passes the top (always
          // jumping the header to the top felt like a huge lurch when a
          // high-up accordion like Colour was tapped). The scrolling
          // element is the active .bm2__menu (overflow-y:auto) — NOT
          // .bm2__scroll, which is overflow:hidden.
          // Timing matters: the body expands via a .25s grid-rows
          // transition, and until it finishes the menu's scrollHeight
          // hasn't grown — a scroll fired earlier clamps against the
          // pre-expansion limit and goes nowhere. Wait for the expansion
          // (transitionend, with a timer fallback), then measure.
          var scroller = acc.closest('.bm2__menu');
          var body = acc.querySelector('.bm2__acc-body');
          if (scroller) {
            var anchored = false;
            var fallbackTimer = null;
            var anchor = function () {
              if (anchored) return;
              anchored = true;
              if (fallbackTimer) window.clearTimeout(fallbackTimer);
              var accRect = acc.getBoundingClientRect();
              var scRect = scroller.getBoundingClientRect();
              var overflowBottom = accRect.bottom - scRect.bottom + 12;
              if (overflowBottom <= 0) return; // fully visible — don't move
              var headerToTop = accRect.top - scRect.top - 12;
              scroller.scrollBy({ top: Math.min(overflowBottom, headerToTop), behavior: 'smooth' });
            };
            if (body) body.addEventListener('transitionend', anchor, { once: true });
            fallbackTimer = window.setTimeout(anchor, 320);
          }
        }
      });
    });

  })();
